<template>
  <div class="content">
    <div class="login">
      <img
        src="http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e85ec55d03/850490057.png"
        class="title"
        alt=""
      />
      <el-select v-model="value1" placeholder="请选择学校">
        <el-option
          v-for="(item, index) in school"
          :key="item.value"
          :label="item.label"
          :value="index"
        >
        </el-option>
      </el-select>
      <el-select v-model="value2" placeholder="请选择班级">
        <el-option
          v-for="(item, index) in classList"
          :key="item.value"
          :label="item.label"
          :value="index"
        >
        </el-option>
      </el-select>
      <el-input
        class="inputElement"
        v-model="name"
        placeholder="请输入姓名"
      ></el-input>
      <div class="submit" @click="go">登录</div>
    </div>
    <div class="tag">Powered By Growlib.i</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      school: [
        {
          label: '北京第56中学'
        },
        {
          label: '北京第3中学'
        }
      ],
      classList: [
        {
          label: '初一（1）班'
        },
        {
          label: '初一（2）班'
        }
      ],
      name: '',
      value1: '',
      value2: ''
    };
  },
  created() {
    setInterval(() => {
      let baiduDom = document.getElementById('newBridge');
      baiduDom.setAttribute('style', 'display: none');
      // console.log(document.getElementsByTagName('html'))
      // document
      //   .getElementsByTagName('html')[0]
      //   .setAttribute('style', 'font-size: 60px !important');
    });

    // baiduDom.setAttribute('style', 'font-size: 60px !important')
  },
  methods: {
    go() {
      sessionStorage.examTime = new Date().getTime()
      this.$router.push({
        name: 'educationVideo'
      })
    }
  },
};
</script>

<style lang="less" scoped>
.content {
  width: 100%;
  height: 100vh;
  background-image: url(http://growlib-glp-public.oss-cn-beijing.aliyuncs.com/res/1_624e853b4925a/781805511.png);
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  .login {
    width: 750px;
    height: 649px;
    background: #ffffff;
    box-shadow: 0px 0px 23px -14px rgba(0, 0, 0, 0.39);
    border-radius: 20px;
    padding-top: 58px;
    > img {
      width: 545px;
      display: block;
      margin: 0 auto;
      margin-bottom: 78px;
    }
    /deep/ .el-select,
    /deep/ .el-input {
      width: 512px;
      height: 70px;
      margin: 0 auto;
      display: block;
      margin-top: 30px;
      display: block;
      input {
        height: 100%;
        font-size: 20px;
      }
    }
    .submit {
      width: 347px;
      height: 70px;
      background: #4594fb;
      box-shadow: 0px 10px 13px -4px rgba(41, 54, 242, 0.31),
        inset 0px 3px 8px 0px rgba(255, 255, 255, 0.48);
      border-radius: 6px;
      opacity: 0.59;
      margin: 0 auto;
      margin-top: 50px;
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      line-height: 70px;
      text-align: center;
      cursor: pointer;
    }
  }
  .tag {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 25px;
    left: 0;
    font-size: 14px;
    font-weight: 400;
    color: #a6a9b1;
    line-height: 20px;
  }
}
</style>
<style>
#newBridge {
  display: none !important;
}
.el-select-dropdown__item span {
  font-size: 20px;
  font-weight: 400;
}
::-webkit-input-placeholder { font-size: 18px !important; }
::-moz-placeholder { font-size: 18px; } /* firefox 19+ */
:-ms-input-placeholder { font-size: 18px; } /* ie */
input:-moz-placeholder { font-size: 18px; }
</style>
